import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {replaceAutoHost} from 'hiya-common/src/utils/host/AutoHost'
import {useSelector} from 'react-redux'

// [亲密度H5首页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=122798522
export const relation_homepage = createAsyncThunk(
  'ChatCp/live/socialize/relation_homepage',
  async (arg: {peer_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'is_anchor'
          | 'my_info'
          | 'other_info'
          | 'relation'
          | 'privilege_lst'
          | 'treasure_box_list'
          | 'week_score_increment'
        >
      >
    >('/live/socialize/relation_homepage', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// [亲密度H5首页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=122798522
export const treasure_box_list = createAsyncThunk(
  'ChatCp/live/socialize/treasure_box_list',
  async (arg: {peer_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'treasure_box_list'>>
    >('/live/socialize/relation_homepage', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// [亲密度H5-任务列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=122798579
export const relation_mission_list = createAsyncThunk(
  'ChatCp/live/socialize/relation_mission_list',
  async (arg: {peer_id: number}, store: any) => {
    const resp = await http.post('/live/socialize/relation_mission_list', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 【亲密度H5-展示任务列表】http://wiki.xunlei.cn/pages/viewpage.action?pageId=122804577
export const show_relation_mission = createAsyncThunk(
  'ChatCp/live/socialize/show_relation_mission',
  async (arg: {peer_id: number}, store: any) => {
    const resp = await http.post('/live/socialize/show_relation_mission', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// 【亲密度宝箱-领取亲密度宝箱】http://wiki.xunlei.cn/pages/viewpage.action?pageId=127566417
export const claim_cp_treasure = createAsyncThunk(
  'ChatCp/live/facetime/claim_cp_treasure',
  async (arg: {peer_id: number; treasure_id: number}, store: any) => {
    const resp = await http.post(
      '/live/facetime/claim_cp_treasure',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface Relationship {
  level: number //	等级
  icon: string //	图片地址
  next_level: number //	下一个等级
  score: number //	亲密度
  min_score: number //	当前等级最低亲密度
  max_score: number //	当前等级最高亲密度
  need_score: number //	需要的分数
  score_display: number //	亲密度
  min_score_display: number //	当前等级最低亲密度
  max_score_display: number //	当前等级最高亲密度
  need_score_display: number //	需要的分数
  days: number //	相识天数
  bg_url: string //		背景图
}
interface UserInfo {
  mid: number
  name: string //	昵称
  avatar: string //	头像
  frame: string //	头像框地址
}
export interface PrizeItem {
  type: number // 类型
  name: string // 奖品名称
  prize_img_url: string // 奖品图片url
  count: number // 奖品数量
  count_display: number // 奖品数量
}
export enum BoxStatusEnum {
  未完成 = 0,
  未领取,
  已领取,
}

export interface TreasureBox {
  id: number
  img: string // 礼包宝箱的图片url地址
  status: BoxStatusEnum // 状态，0未完成，1未领取，2已领取
  increment_score: number // 累计亲密度
  increment_score_display: number // 累计亲密度
  prize_list: PrizeItem[] // 奖品列表
  scheme: string // 跳转路径scheme
}
export interface InitialStateType {
  is_anchor?: boolean // 是否达人
  my_info?: UserInfo
  other_info?: UserInfo
  relation?: Relationship
  // 特权等级
  privilege_lst?: {
    desc: string //	描述
    image: string //	主图地址
    level: number //	解锁所需等级
    icon: string //	缩略图地址
    locked: boolean
  }[]
  ext_info?: any // 需要打点上报的内容
  dot?: boolean
  treasure_box_list?: TreasureBox[]
  week_score_increment?: number
  week_score_increment_display?: number
  mission_list?: {
    job_id: number //		唯一ID
    job_icon: string //	图片地址
    job_name: string //	任务标题
    job_desc: string //	任务描述
    job_status: number //	状态	0. 未完成 1. 已完成
    jump_url: string //	跳转scheme
  }[]
  /** 是否显示额外分成比例	 */
  is_show_extra_point_reward?: boolean
  /** 是否显示亲密度宝箱	 */
  is_show_treasure_box?: boolean

  is_text_app?: boolean
}

const initialState: InitialStateType = {
  mission_list: [],
}

export const ChatCpSlice = createSlice({
  name: 'ChatCp',
  initialState,
  reducers: {
    updateRedDot: (state, action) => {
      Object.assign(state, {
        dot: false,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(relation_homepage.fulfilled, (state, action) => {
      const {privilege_lst, relation, ...rest} = action.payload
      Object.assign(state, {
        ...rest,
        relation,
        privilege_lst: privilege_lst.map((item) => ({
          ...item,
          locked: item.level > relation.level,
        })),
      })
    })

    builder.addCase(treasure_box_list.fulfilled, (state, action) => {
      const {treasure_box_list: list} = action.payload
      Object.assign(state, {
        treasure_box_list: list,
      })
    })

    builder.addCase(relation_mission_list.fulfilled, (state, action) => {
      const {list} = action.payload
      Object.assign(
        state.mission_list,
        list?.map(
          (mi: {
            id: number //		唯一ID
            icon: string //	图片地址
            title: string //	任务标题
            desc: string //	任务描述
            current: number //	当前次数
            target: number //	目标次数
            status: number //	状态	0. 未完成 1. 已完成
            jump_url: string //	跳转scheme
          }) => ({
            job_id: mi.id,
            job_name: `${mi.title}${
              mi.target ? `(${mi.current}/${mi.target})` : ''
            } `,
            job_desc: mi.desc,
            job_icon: replaceAutoHost(mi.icon),
            job_status: {
              0: 0,
              1: 2,
            }[mi.status],
            job_type: 1,
            jump_url: mi.jump_url,
          })
        )
      )
    })
  },
})
export default ChatCpSlice.reducer
export const ChatCpActions = ChatCpSlice.actions

export const useChatCpState = () => {
  const data = useSelector((state) => {
    return state.ChatCp
  })
  return data
}
